import React, { useEffect, useMemo, useState } from 'react';
import {
  Alert, Box, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle,
  IconButton, InputAdornment, MenuItem, Pagination, Paper, Switch, TextField, Tooltip, Typography
} from '@mui/material';
import {
  Add, BusinessOutlined, DeleteOutline, EditOutlined, FactoryOutlined,
  LocationOnOutlined, PeopleOutline, PersonAddAltOutlined, KeyOutlined,
  Visibility, VisibilityOff, DashboardOutlined, HistoryOutlined,
  LoginOutlined, Inventory2Outlined, ShieldOutlined, SearchOutlined, SortOutlined, PictureAsPdfOutlined
} from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';
import { apiFetch } from '../services/api';
import { useLogowanie } from '../context/KontekstLogowania';
import Logi from './Logi';

const card={
  border:'1px solid #e3eaf3',
  boxShadow:'0 8px 26px rgba(18,46,84,.055)',
  borderRadius:3,
  bgcolor:'#fff'
};

function SectionHeader({title,subtitle,buttonLabel,onClick,icon}) {
  return <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:2,mb:2,flexWrap:'wrap'}}>
    <Box sx={{display:'flex',gap:1.2}}>
      <Box sx={{width:40,height:40,borderRadius:2,bgcolor:'#eef4ff',color:'#2364d8',display:'grid',placeItems:'center'}}>{icon}</Box>
      <Box>
        <Typography variant="h6" fontWeight={900}>{title}</Typography>
        {subtitle && <Typography variant="body2" color="text.secondary">{subtitle}</Typography>}
      </Box>
    </Box>
    {buttonLabel && <Button variant="contained" startIcon={<Add/>} onClick={onClick}>{buttonLabel}</Button>}
  </Box>;
}

function SimpleList({children}) {
  return <Paper sx={{...card,p:2}}>{children}</Paper>;
}

function StatCard({label,value,icon,accent='#2364d8'}) {
  return <Paper sx={{...card,p:2.2,minHeight:118}}>
    <Box sx={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:2}}>
      <Box>
        <Typography variant="body2" color="text.secondary" fontWeight={750}>{label}</Typography>
        <Typography variant="h4" fontWeight={950} sx={{mt:.8,color:'#1c2b3a'}}>{value ?? 0}</Typography>
      </Box>
      <Box sx={{width:44,height:44,borderRadius:2.2,display:'grid',placeItems:'center',bgcolor:`${accent}14`,color:accent}}>
        {icon}
      </Box>
    </Box>
  </Paper>;
}

const sekcje = {
  dashboard:'Dashboard',
  uzytkownicy:'Użytkownicy i konta',
  wnioski:'Wnioski o usunięcie',
  lokalizacje:'Lokalizacje',
  pracownicy:'Pracownicy',
  'firmy-serwisowe':'Firmy serwisowe',
  producenci:'Producenci',
  role:'Role i uprawnienia',
  logi:'Logi'
};

export default function PanelAdministratora() {
  const { maUprawnienie }=useLogowanie();
  const [params]=useSearchParams();
  const sekcja=sekcje[params.get('sekcja')] ? params.get('sekcja') : 'dashboard';

  const [uzytkownicy,setUzytkownicy]=useState([]),[role,setRole]=useState([]),
    [lokalizacje,setLokalizacje]=useState([]),[pracownicy,setPracownicy]=useState([]),
    [serwisy,setSerwisy]=useState([]),[producenci,setProducenci]=useState([]);
  const [wnioski,setWnioski]=useState([]),[statusWnioskow,setStatusWnioskow]=useState('OCZEKUJE');
  const [dashboard,setDashboard]=useState({logi:[],statystyki:{},oczekujace:[]});
  const [macierzUprawnien,setMacierzUprawnien]=useState({});

  const [open,setOpen]=useState(false),[kontoPotwierdzOpen,setKontoPotwierdzOpen]=useState(false),[openDecyzja,setOpenDecyzja]=useState(false),[editOpen,setEditOpen]=useState(false),[deleteOpen,setDeleteOpen]=useState(false);
  const [wybrany,setWybrany]=useState(null),[komentarz,setKomentarz]=useState(''),[blad,setBlad]=useState(''),[info,setInfo]=useState('');
  const [konto,setKonto]=useState({email:'',imie:'',nazwisko:'',id_roli:'',haslo_tymczasowe:'',powtorz_haslo:''});
  const [kontoBlad,setKontoBlad]=useState('');
  const [pokazTymczasowe,setPokazTymczasowe]=useState(false);
  const [pokazPowtorzTymczasowe,setPokazPowtorzTymczasowe]=useState(false);
  const [kontoEdit,setKontoEdit]=useState(null);
  const [slownikOpen,setSlownikOpen]=useState(null);
  const [slownikPotwierdzOpen,setSlownikPotwierdzOpen]=useState(false);
  const [slownikTryb,setSlownikTryb]=useState('dodaj');
  const [slownikId,setSlownikId]=useState(null);
  const [szukajSlownik,setSzukajSlownik]=useState('');
  const [szukajUzytkownik,setSzukajUzytkownik]=useState('');
  const [statusUzytkownik,setStatusUzytkownik]=useState('WSZYSTKIE');
  const [sortUzytkownik,setSortUzytkownik]=useState('NAZWA_ASC');
  const [stronaUzytkownik,setStronaUzytkownik]=useState(1);
  const [statusSlownik,setStatusSlownik]=useState('AKTYWNE');
  const [sortSlownik,setSortSlownik]=useState('NAZWA_ASC');
  const [stronaSlownik,setStronaSlownik]=useState(1);
  const NA_STRONIE=10;
  const pustySlownik={
    nazwa:'',kod_lokalizacji:'',miasto:'',ulica:'',numer_budynku:'',budynek:'',pietro:'',pomieszczenie:'',opis:'',
    imie:'',nazwisko:'',email:'',stanowisko:'',dzial:'',numer_pracownika:'',
    nip:'',telefon:'',adres:'',osoba_kontaktowa:'',uwagi:''
  };
  const [slownikForm,setSlownikForm]=useState(pustySlownik);

  const load=async()=>{
    try{
      const [u,r,l,pr,s,p]=await Promise.all([
        apiFetch('/admin/uzytkownicy'),apiFetch('/admin/role'),
        apiFetch('/admin/lokalizacje'),apiFetch('/admin/pracownicy'),
        apiFetch('/admin/firmy-serwisowe'),apiFetch('/admin/producenci')
      ]);
      setUzytkownicy(u);setRole(r);setLokalizacje(l);setPracownicy(pr);setSerwisy(s);setProducenci(p);
    }catch(e){setBlad(e.message);}
  };

  const loadWnioski=async()=>{
    if(!maUprawnienie('ASSET_DELETE_APPROVE')) return;
    try{setWnioski(await apiFetch(`/admin/wnioski-usuniecia?status=${statusWnioskow}`));}
    catch(e){setBlad(e.message);}
  };

  const loadDashboard=async()=>{
    try{
      const [u,oczekujace,logi,statystyki]=await Promise.all([
        apiFetch('/admin/uzytkownicy'),
        apiFetch('/admin/wnioski-usuniecia?status=OCZEKUJE'),
        apiFetch('/logi?limit=500'),
        apiFetch('/statystyki')
      ]);
      setDashboard({
        logi:logi?.dane||[],
        statystyki:statystyki||{},
        oczekujace:Array.isArray(oczekujace)?oczekujace:[],
      });
      setUzytkownicy(u||[]);
    }catch(e){setBlad(e.message);}
  };

  useEffect(()=>{load();loadDashboard();},[]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(()=>{loadWnioski();},[statusWnioskow]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
    if(['lokalizacje','pracownicy','firmy-serwisowe','producenci'].includes(sekcja)){
      setSzukajSlownik('');
      setStatusSlownik('AKTYWNE');
      setSortSlownik('NAZWA_ASC');
      setStronaSlownik(1);
    }
  },[sekcja]);


  useEffect(()=>{
    if(!role.length) return;
    Promise.all(role.map(async r=>{
      const uprawnienia=await apiFetch(`/admin/role/${r.id_roli}/uprawnienia`);
      return [r.nazwa,new Set((uprawnienia||[]).map(p=>p.kod))];
    }))
      .then(entries=>setMacierzUprawnien(Object.fromEntries(entries)))
      .catch(e=>setBlad(e.message));
  },[role]);

  const potwierdzFormularzKonta=()=>{
    setKontoBlad('');setInfo('');
    if(!konto.imie?.trim()||!konto.nazwisko?.trim()||!konto.email?.trim()||!konto.id_roli){setKontoBlad('Uzupełnij imię, nazwisko, e-mail i rolę.');return;}
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(konto.email.trim())){setKontoBlad('Podaj poprawny adres e-mail.');return;}
    const h=konto.haslo_tymczasowe||'';
    if(h.length<8 || !/[A-ZĄĆĘŁŃÓŚŹŻ]/.test(h) || !/[^A-Za-z0-9ĄĆĘŁŃÓŚŹŻąćęłńóśźż]/.test(h)){setKontoBlad('Hasło musi mieć co najmniej 8 znaków, co najmniej jedną wielką literę i jeden znak specjalny.');return;}
    if(konto.haslo_tymczasowe!==konto.powtorz_haslo){setKontoBlad('Hasła tymczasowe nie są takie same.');return;}
    setKontoPotwierdzOpen(true);
  };

  const dodaj=async()=>{
    try{
      setBlad('');setInfo('');
      if(konto.haslo_tymczasowe!==konto.powtorz_haslo){setBlad('Hasła tymczasowe nie są takie same.');return;}
      const r=await apiFetch('/admin/uzytkownicy',{
        method:'POST',
        body:JSON.stringify({
          email:konto.email,imie:konto.imie,nazwisko:konto.nazwisko,id_roli:konto.id_roli,
          haslo_tymczasowe:konto.haslo_tymczasowe
        })
      });
      setKontoPotwierdzOpen(false);setOpen(false);
      setKonto({email:'',imie:'',nazwisko:'',id_roli:'',haslo_tymczasowe:'',powtorz_haslo:''});
      setInfo(`Utworzono konto ${r.login}.`);
      await load();await loadDashboard();
    }catch(e){setKontoBlad(e.message);setKontoPotwierdzOpen(false);}
  };

  const otworzEdycje=u=>{setKontoEdit({...u,status_konta:u.status_konta||(u.aktywne?'AKTYWNE':'NIEAKTYWNE')});setEditOpen(true);};
  const zapiszEdycje=async()=>{try{setBlad('');await apiFetch(`/admin/uzytkownicy/${kontoEdit.id_konta}`,{method:'PATCH',body:JSON.stringify(kontoEdit)});setEditOpen(false);setKontoEdit(null);await load();await loadDashboard();}catch(e){setBlad(e.message);}};
  const usunKonto=async()=>{try{setBlad('');setInfo('');await apiFetch(`/admin/uzytkownicy/${kontoEdit.id_konta}`,{method:'DELETE'});setDeleteOpen(false);setKontoEdit(null);await load();await loadDashboard();}catch(e){setDeleteOpen(false);setBlad(e.message);}};
  const wyslijResetHasla=async(u)=>{try{setBlad('');setInfo('');await apiFetch(`/admin/uzytkownicy/${u.id_konta}/reset-hasla`,{method:'POST'});setInfo(`Wysłano kod resetowania hasła do ${u.email}.`);}catch(e){setBlad(e.message);}};
  const wymusZmianeHasla=async(u)=>{try{setBlad('');setInfo('');await apiFetch(`/admin/uzytkownicy/${u.id_konta}/wymus-zmiane-hasla`,{method:'POST'});setInfo(`Przy następnym logowaniu użytkownik ${u.login} będzie musiał zmienić hasło.`);await load();}catch(e){setBlad(e.message);}};

  const zmienStatusKontaSzybko=async(u)=>{
    try{
      setBlad('');setInfo('');
      const aktywne=statusKonta(u)==='AKTYWNE';
      const nowyStatus=aktywne?'NIEAKTYWNE':'AKTYWNE';
      await apiFetch(`/admin/uzytkownicy/${u.id_konta}`,{
        method:'PATCH',
        body:JSON.stringify({...u,status_konta:nowyStatus,aktywne:nowyStatus==='AKTYWNE'?1:0})
      });
      setInfo(`${nowyStatus==='AKTYWNE'?'Aktywowano':'Dezaktywowano'} konto ${u.login}.`);
      await load();await loadDashboard();
    }catch(e){setBlad(e.message);}
  };

  const rolaLabel=(rola)=>({USER:'Użytkownik',OPERATOR:'Operator ewidencji',KSIEGOWY:'Księgowy',ADMIN:'Administrator'}[rola]||rola||'—');
  const statusKonta=(u)=>u.status_konta||(u.aktywne?'AKTYWNE':'NIEAKTYWNE');
  const statusStyle=(status)=>status==='AKTYWNE'?{bg:'#e7f7ed',fg:'#21833d'}:status==='OCZEKUJE'?{bg:'#fff4dc',fg:'#9b5c00'}:{bg:'#eef2f6',fg:'#526173'};

  const konfiguracjaSlownika={
    lokalizacja:{endpoint:'/admin/lokalizacje',id:'id_lokalizacji',active:'aktywna',label:'lokalizację'},
    pracownik:{endpoint:'/admin/pracownicy',id:'id_pracownika',active:'aktywny',label:'pracownika'},
    producent:{endpoint:'/admin/producenci',id:'id_producenta',active:'aktywny',label:'producenta'},
    serwis:{endpoint:'/admin/firmy-serwisowe',id:'id_firmy_serwisowej',active:'aktywna',label:'firmę serwisową'}
  };

  const otworzDodawanieSlownika=(typ)=>{
    setSlownikTryb('dodaj');setSlownikId(null);setSlownikForm({...pustySlownik});setSlownikOpen(typ);setBlad('');
  };

  const otworzEdycjeSlownika=(typ,x)=>{
    const cfg=konfiguracjaSlownika[typ];
    setSlownikTryb('edytuj');setSlownikId(x[cfg.id]);
    setSlownikForm({...pustySlownik,...x});setSlownikOpen(typ);setBlad('');
  };

  const walidujSlownik=()=>{
    if(slownikOpen==='lokalizacja' && !String(slownikForm.nazwa||'').trim()) return 'Podaj nazwę lokalizacji.';
    if(slownikOpen==='lokalizacja' && !/^[A-Za-z0-9][A-Za-z0-9_\-/]{1,19}$/.test(String(slownikForm.kod_lokalizacji||'').trim())) return 'Kod lokalizacji jest wymagany. Użyj 2–20 znaków: liter, cyfr, myślnika, podkreślenia lub ukośnika.';
    if(slownikOpen==='pracownik' && (!String(slownikForm.imie||'').trim() || !String(slownikForm.nazwisko||'').trim())) return 'Podaj imię i nazwisko pracownika.';
    if(slownikOpen==='pracownik' && !/^\d{5}$/.test(String(slownikForm.numer_pracownika||'').trim())) return 'Numer pracownika musi składać się dokładnie z 5 cyfr.';
    if((slownikOpen==='producent'||slownikOpen==='serwis') && !String(slownikForm.nazwa||'').trim()) return 'Podaj nazwę.';
    if(slownikForm.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(slownikForm.email).trim())) return 'Podaj poprawny adres e-mail.';
    if(slownikOpen==='serwis'){const nip=String(slownikForm.nip||'').replace(/\D/g,'');if(nip.length!==10)return 'NIP jest wymagany i powinien zawierać dokładnie 10 cyfr.';}
    return '';
  };

  const wykonajZapisSlownika=async()=>{
    try{
      const cfg=konfiguracjaSlownika[slownikOpen];
      const url=slownikTryb==='edytuj'?`${cfg.endpoint}/${slownikId}`:cfg.endpoint;
      await apiFetch(url,{method:slownikTryb==='edytuj'?'PATCH':'POST',body:JSON.stringify(slownikForm)});
      setInfo(`${slownikTryb==='edytuj'?'Zapisano zmiany':'Dodano'} ${cfg.label}.`);
      setSlownikPotwierdzOpen(false);setSlownikOpen(null);setSlownikForm({...pustySlownik});setSlownikId(null);
      await load();await loadDashboard();
    }catch(e){setSlownikPotwierdzOpen(false);setBlad(e.message);}
  };

  const zapiszSlownik=async()=>{
    setBlad('');setInfo('');
    const b=walidujSlownik();if(b){setBlad(b);return;}
    if(slownikTryb==='dodaj'){setSlownikPotwierdzOpen(true);return;}
    await wykonajZapisSlownika();
  };

  const podsumowanieSlownika=()=>{
    if(slownikOpen==='lokalizacja') return [
      ['Kod',slownikForm.kod_lokalizacji],['Nazwa',slownikForm.nazwa],['Miasto',slownikForm.miasto],
      ['Ulica',[slownikForm.ulica,slownikForm.numer_budynku].filter(Boolean).join(' ')],
      ['Budynek / oddział',slownikForm.budynek],['Piętro',slownikForm.pietro],['Pokój',slownikForm.pomieszczenie]
    ];
    if(slownikOpen==='pracownik') return [
      ['Numer pracownika',slownikForm.numer_pracownika],['Imię i nazwisko',`${slownikForm.imie||''} ${slownikForm.nazwisko||''}`.trim()],
      ['E-mail',slownikForm.email],['Stanowisko',slownikForm.stanowisko],['Dział',slownikForm.dzial]
    ];
    if(slownikOpen==='serwis') return [
      ['Nazwa',slownikForm.nazwa],['NIP',slownikForm.nip],['E-mail',slownikForm.email],
      ['Telefon',slownikForm.telefon],['Osoba kontaktowa',slownikForm.osoba_kontaktowa],['Adres',slownikForm.adres]
    ];
    return [['Nazwa producenta',slownikForm.nazwa],['Opis',slownikForm.opis]];
  };

  const zmienStatusSlownika=async(typ,x)=>{
    setBlad('');setInfo('');
    try{
      const cfg=konfiguracjaSlownika[typ];
      const obecny=!!x[cfg.active];
      await apiFetch(`${cfg.endpoint}/${x[cfg.id]}/status`,{method:'PATCH',body:JSON.stringify({[cfg.active]:!obecny})});
      setInfo(`${!obecny?'Aktywowano':'Dezaktywowano'} ${cfg.label}.`);
      await load();await loadDashboard();
    }catch(e){setBlad(e.message);}
  };

  const przygotujUzytkownikow=()=>{
    const q=szukajUzytkownik.trim().toLowerCase();
    let wynik=[...uzytkownicy];
    if(statusUzytkownik!=='WSZYSTKIE') wynik=wynik.filter(u=>statusKonta(u)===statusUzytkownik);
    if(q) wynik=wynik.filter(u=>[
      u.login,u.imie,u.nazwisko,u.email,rolaLabel(u.rola),statusKonta(u)
    ].some(v=>String(v||'').toLowerCase().includes(q)));
    wynik.sort((a,b)=>{
      const an=`${a.nazwisko||''} ${a.imie||''}`.trim();
      const bn=`${b.nazwisko||''} ${b.imie||''}`.trim();
      if(sortUzytkownik==='NAZWA_DESC') return bn.localeCompare(an,'pl',{sensitivity:'base'});
      if(sortUzytkownik==='LOGIN_ASC') return String(a.login||'').localeCompare(String(b.login||''),'pl',{sensitivity:'base'});
      if(sortUzytkownik==='LOGIN_DESC') return String(b.login||'').localeCompare(String(a.login||''),'pl',{sensitivity:'base'});
      if(sortUzytkownik==='OSTATNIE') return new Date(b.ostatnie_logowanie||0)-new Date(a.ostatnie_logowanie||0);
      return an.localeCompare(bn,'pl',{sensitivity:'base'});
    });
    const strony=Math.max(1,Math.ceil(wynik.length/NA_STRONIE));
    const bezpiecznaStrona=Math.min(stronaUzytkownik,strony);
    return {
      dane:wynik.slice((bezpiecznaStrona-1)*NA_STRONIE,bezpiecznaStrona*NA_STRONIE),
      liczba:wynik.length,strony,bezpiecznaStrona
    };
  };

  const aktywnyRekord=(x,typ)=>typ==='pracownik'||typ==='producent' ? !!x.aktywny : !!x.aktywna;

  const przygotujListe=(lista,pola,typ)=>{
    const q=szukajSlownik.trim().toLowerCase();
    let wynik=[...lista];

    if(statusSlownik==='AKTYWNE') wynik=wynik.filter(x=>aktywnyRekord(x,typ));
    if(statusSlownik==='NIEAKTYWNE') wynik=wynik.filter(x=>!aktywnyRekord(x,typ));
    if(q) wynik=wynik.filter(x=>pola.some(f=>String(x[f]??'').toLowerCase().includes(q)));

    const wartoscNazwy=x=>{
      if(typ==='pracownik') return `${x.nazwisko||''} ${x.imie||''}`.trim();
      return String(x.nazwa||'');
    };
    wynik.sort((a,b)=>{
      if(sortSlownik==='NAZWA_DESC') return wartoscNazwy(b).localeCompare(wartoscNazwy(a),'pl',{sensitivity:'base'});
      if(sortSlownik==='KOD_ASC') return String(a.kod_lokalizacji||a.numer_pracownika||a.nip||'').localeCompare(String(b.kod_lokalizacji||b.numer_pracownika||b.nip||''),'pl',{numeric:true});
      if(sortSlownik==='KOD_DESC') return String(b.kod_lokalizacji||b.numer_pracownika||b.nip||'').localeCompare(String(a.kod_lokalizacji||a.numer_pracownika||a.nip||''),'pl',{numeric:true});
      return wartoscNazwy(a).localeCompare(wartoscNazwy(b),'pl',{sensitivity:'base'});
    });

    const strony=Math.max(1,Math.ceil(wynik.length/NA_STRONIE));
    const bezpiecznaStrona=Math.min(stronaSlownik,strony);
    const dane=wynik.slice((bezpiecznaStrona-1)*NA_STRONIE,bezpiecznaStrona*NA_STRONIE);
    return {dane,liczba:wynik.length,strony,bezpiecznaStrona};
  };

  const KontrolkiListy=({placeholder='Szukaj po nazwie, kodzie lub danych...',pokazKod=true})=><Paper sx={{...card,p:1.5,mb:2}}>
    <Box sx={{display:'flex',gap:1.2,alignItems:'center',justifyContent:'space-between',flexWrap:'wrap'}}>
      <TextField
        size="small"
        placeholder={placeholder}
        value={szukajSlownik}
        onChange={e=>{setSzukajSlownik(e.target.value);setStronaSlownik(1);}}
        sx={{minWidth:{xs:'100%',sm:360}}}
        InputProps={{startAdornment:<InputAdornment position="start"><SearchOutlined fontSize="small"/></InputAdornment>}}
      />
      <Box sx={{display:'flex',gap:.7,flexWrap:'wrap',alignItems:'center'}}>
        {[['AKTYWNE','Aktywne'],['NIEAKTYWNE','Nieaktywne'],['WSZYSTKIE','Wszystkie']].map(([v,l])=>
          <Button key={v} size="small" variant={statusSlownik===v?'contained':'text'} onClick={()=>{setStatusSlownik(v);setStronaSlownik(1);}} sx={{textTransform:'none',fontWeight:800}}>{l}</Button>
        )}
        <TextField select size="small" value={sortSlownik} onChange={e=>{setSortSlownik(e.target.value);setStronaSlownik(1);}} sx={{minWidth:190}}
          InputProps={{startAdornment:<InputAdornment position="start"><SortOutlined fontSize="small"/></InputAdornment>}}>
          <MenuItem value="NAZWA_ASC">Nazwa A–Z</MenuItem>
          <MenuItem value="NAZWA_DESC">Nazwa Z–A</MenuItem>
          {pokazKod && <MenuItem value="KOD_ASC">Kod / numer rosnąco</MenuItem>}
          {pokazKod && <MenuItem value="KOD_DESC">Kod / numer malejąco</MenuItem>}
        </TextField>
      </Box>
    </Box>
  </Paper>;

  const PaginacjaListy=({meta})=>meta.liczba>0?<Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:2,pt:2,flexWrap:'wrap'}}>
    <Typography variant="caption" color="text.secondary">
      Wyniki {((meta.bezpiecznaStrona-1)*NA_STRONIE)+1}–{Math.min(meta.bezpiecznaStrona*NA_STRONIE,meta.liczba)} z {meta.liczba}
    </Typography>
    <Pagination count={meta.strony} page={meta.bezpiecznaStrona} onChange={(_,p)=>setStronaSlownik(p)} color="primary" size="small"/>
  </Box>:null;

  const decyzja=async(d)=>{
    setBlad('');
    try{
      if(d==='ODRZUCONY' && !komentarz.trim()){setBlad('Podaj powód odrzucenia wniosku.');return;}
      await apiFetch(`/admin/wnioski-usuniecia/${wybrany.id_wniosku}/decyzja`,{
        method:'PATCH',body:JSON.stringify({decyzja:d,komentarz})
      });
      setOpenDecyzja(false);setWybrany(null);setKomentarz('');
      if(d==='ZATWIERDZONY') setInfo('Środek został trwale usunięty. Protokół jest dostępny w zakładce „Zaakceptowane”.');
      await loadWnioski();await loadDashboard();
    } catch(e){setBlad(e.message);}
  };

  const snapshot=w=>{try{return typeof w.snapshot_srodka==='string'?JSON.parse(w.snapshot_srodka):w.snapshot_srodka||{};}catch{return {};}};

  const drukujProtokolUsuniecia=(w)=>{
    if(!w || w.status!=='ZATWIERDZONY') return;
    const s=snapshot(w);
    const esc=(v)=>String(v??'—').replace(/[&<>"']/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch]));
    const data=(v)=>{
      if(!v) return '—';
      const d=new Date(v);
      return Number.isNaN(d.getTime()) ? String(v).slice(0,10) : d.toLocaleDateString('pl-PL');
    };
    const dataCzas=(v)=>{
      if(!v) return '—';
      const d=new Date(v);
      return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleString('pl-PL');
    };
    const pieniadze=(v)=>{
      if(v===null||v===undefined||v==='') return '—';
      const n=Number(v);
      return Number.isFinite(n) ? n.toLocaleString('pl-PL',{minimumFractionDigits:2,maximumFractionDigits:2})+' zł' : String(v);
    };
    const pole=(etykieta,wartosc)=>`<div class="field"><div class="label">${esc(etykieta)}</div><div class="value">${esc(wartosc)}</div></div>`;
    const amort=s.amortyzacja||null;
    const parametry=Array.isArray(s.parametry_techniczne)?s.parametry_techniczne:[];
    const rok=w.data_decyzji ? new Date(w.data_decyzji).getFullYear() : new Date().getFullYear();
    const nr=`US/${w.id_wniosku}/${rok}`;

    const paramHtml=parametry.length?`<section><h2>Parametry techniczne</h2><table><thead><tr><th>Parametr</th><th>Wartość</th></tr></thead><tbody>${parametry.map(p=>`<tr><td>${esc(p.nazwa)}</td><td>${esc(`${p.wartosc??'—'}${p.jednostka?` ${p.jednostka}`:''}`)}</td></tr>`).join('')}</tbody></table></section>`:'';
    const amortHtml=amort?`<section><h2>Amortyzacja na dzień usunięcia</h2><div class="grid">${[
      pole('Metoda',amort.metoda_kod||'—'),
      pole('Wartość początkowa',pieniadze(amort.wartosc_poczatkowa)),
      pole('Stawka zastosowana',amort.stawka_zastosowana_proc!=null?`${amort.stawka_zastosowana_proc}%`:'—'),
      pole('Współczynnik degresywny',amort.wspolczynnik_degresywny||'—'),
      pole('Data rozpoczęcia',data(amort.data_rozpoczecia)),
      pole('Umorzenie',pieniadze(amort.umorzenie_na_dzien_usuniecia)),
      pole('Wartość netto',pieniadze(amort.wartosc_netto_na_dzien_usuniecia)),
      pole('Status amortyzacji',amort.status||'—')
    ].join('')}</div></section>`:'';

    const win=window.open('','_blank','width=980,height=900');
    if(!win){setBlad('Przeglądarka zablokowała okno protokołu. Zezwól na wyskakujące okna dla aplikacji i spróbuj ponownie.');return;}
    win.opener=null;
    win.document.open();
    win.document.write(`<!doctype html><html lang="pl"><head><meta charset="utf-8"><title>Protokół usunięcia ${esc(nr)}</title><style>
      @page{size:A4;margin:16mm}*{box-sizing:border-box}body{font-family:Arial,"DejaVu Sans",sans-serif;color:#172433;margin:0;font-size:12px;line-height:1.4}.top{border-bottom:3px solid #203a5f;padding-bottom:14px;margin-bottom:18px}.title{font-size:20px;font-weight:800;letter-spacing:.2px}.meta{display:flex;justify-content:space-between;gap:20px;margin-top:8px;color:#536274}.badge{display:inline-block;border:1px solid #9fc9aa;background:#edf8f0;color:#216b35;padding:4px 9px;border-radius:999px;font-weight:700}section{margin-top:18px;break-inside:avoid}h2{font-size:13px;text-transform:uppercase;letter-spacing:.5px;color:#203a5f;border-bottom:1px solid #d9e0e8;padding-bottom:5px;margin:0 0 10px}.grid{display:grid;grid-template-columns:1fr 1fr;gap:0 18px}.field{display:grid;grid-template-columns:155px 1fr;border-bottom:1px solid #e7ebf0;padding:5px 0;min-height:28px}.label{color:#657385;font-weight:700}.value{font-weight:600;overflow-wrap:anywhere}.note{border:1px solid #d9e0e8;background:#fafbfd;padding:9px 11px;border-radius:4px;white-space:pre-wrap;margin:6px 0}table{width:100%;border-collapse:collapse}th,td{border:1px solid #d9e0e8;padding:6px 8px;text-align:left;vertical-align:top}th{background:#f4f7fa;color:#34475e}.signatures{display:grid;grid-template-columns:1fr 1fr;gap:48px;margin-top:48px}.signature{text-align:center;padding-top:30px;border-top:1px solid #607086;color:#536274}.footer{margin-top:24px;font-size:9px;color:#7a8796;text-align:center}.no-print{margin:0 0 16px;text-align:right}.no-print button{border:0;background:#2364d8;color:white;padding:9px 14px;border-radius:6px;font-weight:700;cursor:pointer}@media print{.no-print{display:none}body{font-size:11px}.top{margin-top:0}}
    </style></head><body><div class="no-print"><button onclick="window.print()">Drukuj / zapisz jako PDF</button></div><div class="top"><div class="title">PROTOKÓŁ TRWAŁEGO USUNIĘCIA ŚRODKA TRWAŁEGO</div><div class="meta"><div>Nr protokołu: <b>${esc(nr)}</b></div><div><span class="badge">ZATWIERDZONY</span></div></div></div>
    <section><h2>Dane środka trwałego</h2><div class="grid">${[
      pole('Numer unikatowy',s.numer_unikatowy),pole('Numer INW',s.numer_inw),pole('Numer seryjny',s.numer_seryjny),pole('KŚT',`${s.symbol_kst||'—'}${s.nazwa_kst?` - ${s.nazwa_kst}`:''}`),
      pole('Kategoria',s.kategoria),pole('Producent',s.producent),pole('Model',s.model),pole('Nazwa / typ',s.nazwa_indeksu),pole('Status przed usunięciem',s.status),pole('Lokalizacja',s.lokalizacja),pole('Przypisany pracownik',s.uzytkownik),pole('Firma serwisowa',s.firma_serwisowa),
      pole('Data produkcji',data(s.data_produkcji)),pole('Data zakupu',data(s.data_zakupu)),pole('Data przyjęcia',data(s.data_przyjecia)),pole('Gwarancja do',data(s.data_gwarancji_do)),pole('Numer zamówienia',s.numer_zamowienia),pole('Oprogramowanie',s.oprogramowanie)
    ].join('')}</div></section>
    ${amortHtml}${paramHtml}
    <section><h2>Podstawa i decyzja o usunięciu</h2><div class="grid">${[
      pole('Wnioskodawca',w.wnioskodawca_nazwa||'—'),pole('Data złożenia wniosku',dataCzas(w.data_zgloszenia)),pole('Administrator',w.administrator_nazwa||'—'),pole('Data decyzji',dataCzas(w.data_decyzji))
    ].join('')}</div><div class="label" style="margin-top:10px">Powód trwałego usunięcia</div><div class="note">${esc(w.powod||'—')}</div>${w.komentarz_administratora?`<div class="label" style="margin-top:10px">Komentarz administratora</div><div class="note">${esc(w.komentarz_administratora)}</div>`:''}</section>
    ${(s.komentarz||s.notatka_ewidencja||s.notatka_parametry)?`<section><h2>Notatki zapisane przy środku</h2>${s.komentarz?`<div class="label">Notatka ogólna</div><div class="note">${esc(s.komentarz)}</div>`:''}${s.notatka_ewidencja?`<div class="label">Notatka ewidencyjna</div><div class="note">${esc(s.notatka_ewidencja)}</div>`:''}${s.notatka_parametry?`<div class="label">Notatka techniczna</div><div class="note">${esc(s.notatka_parametry)}</div>`:''}</section>`:''}
    <section><h2>Potwierdzenie</h2><p>Niniejszy protokół został utworzony na podstawie danych zachowanych w systemie w momencie zatwierdzenia trwałego usunięcia środka trwałego.</p><div class="signatures"><div class="signature">Administrator / osoba zatwierdzająca</div><div class="signature">Podpis / data</div></div></section><div class="footer">System Ewidencji Środków Trwałych · dokument wygenerowany ${esc(new Date().toLocaleString('pl-PL'))}</div></body></html>`);
    win.document.close();
    win.focus();
    setTimeout(()=>win.print(),350);
  };

  const statusColor = status =>
    status==='OCZEKUJE'?{bg:'#fff4dc',fg:'#9b5c00'}:
    status==='ZATWIERDZONY'?{bg:'#e7f7ed',fg:'#21833d'}:
    status==='ODRZUCONY'?{bg:'#ffe8e8',fg:'#b3261e'}:{bg:'#eef2f6',fg:'#526173'};

  const aktywneKonta=uzytkownicy.filter(u=>statusKonta(u)==='AKTYWNE').length;
  const nieaktywneKonta=uzytkownicy.filter(u=>statusKonta(u)!=='AKTYWNE').length;
  const ostatnieLogowania=useMemo(()=>[...uzytkownicy]
    .filter(u=>u.ostatnie_logowanie)
    .sort((a,b)=>new Date(b.ostatnie_logowanie)-new Date(a.ostatnie_logowanie))
    .slice(0,5),[uzytkownicy]);

  const operacjeDzisiaj=useMemo(()=>{
    const dzis=new Date().toLocaleDateString('pl-PL');
    return dashboard.logi.filter(x=>x.utworzono && new Date(x.utworzono).toLocaleDateString('pl-PL')===dzis).length;
  },[dashboard.logi]);

  const ostatniaAktywnosc=dashboard.logi.slice(0,5);

  const uprawnieniaWidoczne=[
    ['ASSET_CREATE','Dodawanie środków trwałych'],
    ['ASSET_EDIT','Edycja środków trwałych'],
    ['ASSET_EDIT_ACCOUNTING','Edycja danych ewidencyjno-księgowych'],
    ['ASSET_MOVE','Przesuwanie środków trwałych'],
    ['ASSET_DELETE_REQUEST','Składanie wniosków o usunięcie'],
    ['ASSET_DELETE_APPROVE','Akceptacja trwałego usunięcia'],
    ['DEPRECIATION_VIEW','Podgląd amortyzacji'],
    ['DEPRECIATION_MANAGE','Zarządzanie amortyzacją'],
    ['REPORT_VIEW','Raporty'],
    ['REPORT_EXPORT','Eksport raportów'],
    ['DEPRECIATION_REPORT_EXPORT','Eksport raportów amortyzacji'],
    ['AUDIT_VIEW','Podgląd logów'],
    ['USER_MANAGE','Zarządzanie użytkownikami'],
    ['ADMIN_PANEL','Panel administratora']
  ];

  const aktywnosc7Dni=useMemo(()=>{
    const wynik=[];
    for(let i=6;i>=0;i-=1){
      const d=new Date();
      d.setHours(0,0,0,0);
      d.setDate(d.getDate()-i);
      const next=new Date(d);next.setDate(next.getDate()+1);
      const count=dashboard.logi.filter(x=>{
        if(!x.utworzono) return false;
        const dt=new Date(x.utworzono);
        return dt>=d && dt<next;
      }).length;
      wynik.push({label:d.toLocaleDateString('pl-PL',{weekday:'short'}).replace('.',''),count});
    }
    return wynik;
  },[dashboard.logi]);
  const maxAktywnosc=Math.max(1,...aktywnosc7Dni.map(x=>x.count));

  return <Box>
    <Box sx={{mb:2.5}}>
      <Typography variant="h4" fontWeight={900}>Panel administratora</Typography>
      <Typography color="text.secondary">{sekcje[sekcja]}</Typography>
    </Box>

    {blad && <Alert severity="error" sx={{mb:2}} onClose={()=>setBlad('')}>{blad}</Alert>}
    {info && <Alert severity="success" sx={{mb:2}} onClose={()=>setInfo('')}>{info}</Alert>}

    {sekcja==='dashboard' && <>
      <SectionHeader title="Dashboard administratora" subtitle="Najważniejsze informacje o działaniu systemu." icon={<DashboardOutlined/>}/>
      <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',sm:'repeat(2,1fr)',xl:'repeat(5,1fr)'},gap:1.5,mb:2}}>
        <StatCard label="Aktywne konta" value={aktywneKonta} icon={<PeopleOutline/>}/>
        <StatCard label="Nieaktywne konta" value={nieaktywneKonta} icon={<PeopleOutline/>} accent="#64748b"/>
        <StatCard label="Oczekujące wnioski" value={dashboard.oczekujace.length} icon={<DeleteOutline/>} accent="#d97706"/>
        <StatCard label="Operacje dzisiaj" value={operacjeDzisiaj} icon={<HistoryOutlined/>} accent="#6d43b7"/>
        <StatCard label="Środki trwałe" value={dashboard.statystyki.srodki||0} icon={<Inventory2Outlined/>} accent="#21833d"/>
      </Box>

      <Paper sx={{...card,p:2.2,mb:2}}>
        <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:2,mb:2}}>
          <Box>
            <Typography fontWeight={900}>Aktywność w systemie</Typography>
            <Typography variant="body2" color="text.secondary">Liczba zapisanych operacji z ostatnich 7 dni.</Typography>
          </Box>
          <Chip size="small" label="Ostatnie 7 dni" sx={{bgcolor:'#eef4ff',color:'#2364d8',fontWeight:800}}/>
        </Box>
        <Box sx={{height:180,display:'flex',alignItems:'flex-end',gap:{xs:1,sm:2},px:{xs:0,sm:1},pt:1,borderBottom:'1px solid #e5ebf3'}}>
          {aktywnosc7Dni.map((d,i)=><Box key={`${d.label}-${i}`} sx={{flex:1,minWidth:0,height:'100%',display:'flex',flexDirection:'column',justifyContent:'flex-end',alignItems:'center',gap:.7}}>
            <Typography variant="caption" fontWeight={850} color="text.secondary">{d.count}</Typography>
            <Box sx={{width:'72%',maxWidth:48,minHeight:d.count?8:2,height:`${Math.max(2,(d.count/maxAktywnosc)*120)}px`,borderRadius:'8px 8px 2px 2px',background:'linear-gradient(180deg,#2f80ed 0%,#173d73 100%)',transition:'height .2s ease'}}/>
            <Typography variant="caption" color="text.secondary" sx={{textTransform:'capitalize'}}>{d.label}</Typography>
          </Box>)}
        </Box>
      </Paper>

      <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',xl:'1fr 1.25fr'},gap:2}}>
        <Paper sx={{...card,p:2}}>
          <Box sx={{display:'flex',alignItems:'center',gap:1,mb:1.5}}>
            <LoginOutlined color="primary"/><Typography fontWeight={900}>Ostatnie logowania</Typography>
          </Box>
          {ostatnieLogowania.length===0 ? <Typography color="text.secondary">Brak danych o logowaniach.</Typography> :
            ostatnieLogowania.map(u=><Box key={u.id_konta} sx={{display:'grid',gridTemplateColumns:'1.4fr 1fr auto',gap:1,py:1.15,borderBottom:'1px solid #edf1f6',alignItems:'center'}}>
              <Box><Typography variant="body2" fontWeight={800}>{u.imie} {u.nazwisko}</Typography><Typography variant="caption" color="text.secondary">{u.login}</Typography></Box>
              <Chip size="small" label={rolaLabel(u.rola)} sx={{justifySelf:'start',bgcolor:'#eef4ff',color:'#2364d8',fontWeight:750}}/>
              <Typography variant="caption" color="text.secondary">{new Date(u.ostatnie_logowanie).toLocaleString('pl-PL')}</Typography>
            </Box>)
          }
        </Paper>

        <Paper sx={{...card,p:2}}>
          <Box sx={{display:'flex',alignItems:'center',gap:1,mb:1.5}}>
            <HistoryOutlined color="primary"/><Typography fontWeight={900}>Ostatnia aktywność w systemie</Typography>
          </Box>
          {ostatniaAktywnosc.length===0 ? <Typography color="text.secondary">Brak zapisanej aktywności.</Typography> :
            ostatniaAktywnosc.map(x=><Box key={x.id_logu} sx={{display:'grid',gridTemplateColumns:'1.25fr .9fr auto',gap:1,py:1.15,borderBottom:'1px solid #edf1f6',alignItems:'center'}}>
              <Box><Typography variant="body2" fontWeight={800}>{x.opis||x.akcja}</Typography><Typography variant="caption" color="text.secondary">{x.encja||'System'}{x.id_encji?` · ${x.id_encji}`:''}</Typography></Box>
              <Typography variant="body2">{x.uzytkownik||'System'}</Typography>
              <Typography variant="caption" color="text.secondary">{new Date(x.utworzono).toLocaleString('pl-PL')}</Typography>
            </Box>)
          }
        </Paper>
      </Box>
    </>}

    {sekcja==='uzytkownicy' && (()=>{const meta=przygotujUzytkownikow();return <>
      <SectionHeader title="Użytkownicy i konta" subtitle="Zarządzanie kontami, rolami, statusem i bezpieczeństwem użytkowników." buttonLabel="Dodaj użytkownika" onClick={()=>{setKontoBlad('');setOpen(true);}} icon={<PeopleOutline/>}/>
      <Paper sx={{...card,p:1.5,mb:2}}>
        <Box sx={{display:'flex',gap:1.2,alignItems:'center',justifyContent:'space-between',flexWrap:'wrap'}}>
          <TextField size="small" placeholder="Szukaj po loginie, nazwisku, e-mailu lub roli..." value={szukajUzytkownik}
            onChange={e=>{setSzukajUzytkownik(e.target.value);setStronaUzytkownik(1);}} sx={{minWidth:{xs:'100%',sm:380}}}
            InputProps={{startAdornment:<InputAdornment position="start"><SearchOutlined fontSize="small"/></InputAdornment>}}/>
          <Box sx={{display:'flex',gap:.7,alignItems:'center',flexWrap:'wrap'}}>
            {[['WSZYSTKIE','Wszystkie'],['AKTYWNE','Aktywne'],['NIEAKTYWNE','Nieaktywne']].map(([v,l])=>
              <Button key={v} size="small" variant={statusUzytkownik===v?'contained':'text'} onClick={()=>{setStatusUzytkownik(v);setStronaUzytkownik(1);}} sx={{textTransform:'none',fontWeight:800}}>{l}</Button>
            )}
            <TextField select size="small" value={sortUzytkownik} onChange={e=>{setSortUzytkownik(e.target.value);setStronaUzytkownik(1);}} sx={{minWidth:190}}
              InputProps={{startAdornment:<InputAdornment position="start"><SortOutlined fontSize="small"/></InputAdornment>}}>
              <MenuItem value="NAZWA_ASC">Nazwisko A–Z</MenuItem><MenuItem value="NAZWA_DESC">Nazwisko Z–A</MenuItem>
              <MenuItem value="LOGIN_ASC">Login A–Z</MenuItem><MenuItem value="LOGIN_DESC">Login Z–A</MenuItem>
              <MenuItem value="OSTATNIE">Ostatnio logowani</MenuItem>
            </TextField>
          </Box>
        </Box>
      </Paper>
      <SimpleList>
        <Box sx={{display:{xs:'none',xl:'grid'},gridTemplateColumns:'1fr 1.25fr 1.45fr .9fr .9fr 1fr 175px',gap:1.2,px:1,py:1,bgcolor:'#f8fafc',borderRadius:1.5,fontWeight:850,fontSize:13}}>
          <span>Login</span><span>Imię i nazwisko</span><span>E-mail</span><span>Rola</span><span>Status</span><span>Ostatnie logowanie</span><span>Akcje</span>
        </Box>
        {meta.dane.length===0?<Typography color="text.secondary" sx={{py:4,textAlign:'center'}}>Brak użytkowników spełniających wybrane kryteria.</Typography>:meta.dane.map(u=>{
          const status=statusKonta(u),sc=statusStyle(status);
          return <Box key={u.id_konta} sx={{display:'grid',gridTemplateColumns:{xs:'1fr',xl:'1fr 1.25fr 1.45fr .9fr .9fr 1fr 175px'},gap:{xs:.7,xl:1.2},px:1,py:1.45,borderBottom:'1px solid #edf1f6',alignItems:'center',bgcolor:status==='NIEAKTYWNE'?'#f6f7f9':'transparent',opacity:status==='NIEAKTYWNE'?.68:1}}>
            <Typography variant="body2" fontWeight={850}>{u.login}</Typography>
            <Typography variant="body2">{u.imie} {u.nazwisko}</Typography>
            <Typography variant="body2">{u.email}</Typography>
            <Chip size="small" label={rolaLabel(u.rola)} sx={{justifySelf:'start',bgcolor:'#eef4ff',color:'#2364d8',fontWeight:750}}/>
            <Chip size="small" label={status==='AKTYWNE'?'Aktywne':status==='OCZEKUJE'?'Oczekuje':'Nieaktywne'} sx={{justifySelf:'start',bgcolor:sc.bg,color:sc.fg,fontWeight:750}}/>
            <Typography variant="caption" color="text.secondary">{u.ostatnie_logowanie?new Date(u.ostatnie_logowanie).toLocaleString('pl-PL'):'—'}</Typography>
            <Box sx={{display:'flex',gap:.25,justifyContent:'flex-start'}}>
              <Tooltip title="Edytuj konto"><IconButton size="small" color="primary" onClick={()=>otworzEdycje(u)}><EditOutlined fontSize="small"/></IconButton></Tooltip>
              <Tooltip title="Wyślij kod resetu hasła na e-mail"><IconButton size="small" onClick={()=>wyslijResetHasla(u)}><KeyOutlined fontSize="small"/></IconButton></Tooltip>
              {status==='AKTYWNE' && <Tooltip title="Wymuś zmianę hasła przy następnym logowaniu"><IconButton size="small" onClick={()=>wymusZmianeHasla(u)}><LoginOutlined fontSize="small"/></IconButton></Tooltip>}
              <Tooltip title={status==='AKTYWNE'?'Dezaktywuj konto':'Aktywuj konto'}><Switch size="small" checked={status==='AKTYWNE'} onChange={()=>zmienStatusKontaSzybko(u)}/></Tooltip>
              <Tooltip title="Usuń konto, jeśli nie ma historii"><IconButton size="small" color="error" onClick={()=>{setKontoEdit(u);setDeleteOpen(true);}}><DeleteOutline fontSize="small"/></IconButton></Tooltip>
            </Box>
          </Box>;
        })}
        {meta.liczba>0&&<Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:2,pt:2,flexWrap:'wrap'}}>
          <Typography variant="caption" color="text.secondary">Wyniki {((meta.bezpiecznaStrona-1)*NA_STRONIE)+1}–{Math.min(meta.bezpiecznaStrona*NA_STRONIE,meta.liczba)} z {meta.liczba}</Typography>
          <Pagination count={meta.strony} page={meta.bezpiecznaStrona} onChange={(_,p)=>setStronaUzytkownik(p)} color="primary" size="small"/>
        </Box>}
      </SimpleList>
    </>})()}

    {sekcja==='lokalizacje' && (()=>{const meta=przygotujListe(lokalizacje,['kod_lokalizacji','nazwa','miasto','ulica','numer_budynku','budynek','pietro','pomieszczenie','opis'],'lokalizacja');return <>
      <SectionHeader title="Lokalizacje" subtitle="Dokładne miejsca wykorzystywane przy przypisywaniu i przesuwaniu środków." buttonLabel="Dodaj lokalizację" onClick={()=>otworzDodawanieSlownika('lokalizacja')} icon={<LocationOnOutlined/>}/>
      <KontrolkiListy placeholder="Szukaj po kodzie, nazwie, mieście, ulicy, piętrze lub pokoju..."/>
      <SimpleList>
        <Box sx={{display:{xs:'none',xl:'grid'},gridTemplateColumns:'105px 1.25fr 1.25fr .8fr .8fr 105px 100px',gap:1.4,px:1,py:1,bgcolor:'#f8fafc',borderRadius:1.5,fontWeight:850,fontSize:13}}>
          <span>Kod</span><span>Lokalizacja</span><span>Adres</span><span>Piętro</span><span>Pokój</span><span>Status</span><span>Akcje</span>
        </Box>
        {meta.dane.length===0?<Typography color="text.secondary" sx={{py:4,textAlign:'center'}}>Brak lokalizacji spełniających wybrane kryteria.</Typography>:meta.dane.map(x=><Box key={x.id_lokalizacji} sx={{display:'grid',gridTemplateColumns:{xs:'1fr',xl:'105px 1.25fr 1.25fr .8fr .8fr 105px 100px'},gap:1.4,px:1,py:1.4,borderBottom:'1px solid #edf1f6',alignItems:'center',bgcolor:x.aktywna?'transparent':'#f6f7f9',opacity:x.aktywna?1:.67}}>
          <Typography variant="body2" fontWeight={900} color="primary">{x.kod_lokalizacji||'—'}</Typography>
          <Box><Typography variant="body2" fontWeight={850}>{x.nazwa}</Typography><Typography variant="caption" color="text.secondary">{[x.budynek,x.opis].filter(Boolean).join(' · ')||'—'}</Typography></Box>
          <Box><Typography variant="body2">{[x.ulica,x.numer_budynku].filter(Boolean).join(' ')||'—'}</Typography><Typography variant="caption" color="text.secondary">{x.miasto||'—'}</Typography></Box>
          <Typography variant="body2">{x.pietro||'—'}</Typography>
          <Typography variant="body2">{x.pomieszczenie||'—'}</Typography>
          <Chip size="small" label={x.aktywna?'Aktywna':'Nieaktywna'} sx={{justifySelf:'start',bgcolor:x.aktywna?'#e7f7ed':'#eef2f6',color:x.aktywna?'#21833d':'#526173',fontWeight:800}}/>
          <Box sx={{display:'flex',gap:.3,alignItems:'center'}}><Tooltip title="Edytuj lokalizację"><IconButton size="small" color="primary" onClick={()=>otworzEdycjeSlownika('lokalizacja',x)}><EditOutlined fontSize="small"/></IconButton></Tooltip><Tooltip title={x.aktywna?'Dezaktywuj lokalizację':'Aktywuj lokalizację'}><Switch size="small" checked={!!x.aktywna} onChange={()=>zmienStatusSlownika('lokalizacja',x)}/></Tooltip></Box>
        </Box>)}
        <PaginacjaListy meta={meta}/>
      </SimpleList>
    </>})()}

    {sekcja==='pracownicy' && (()=>{const meta=przygotujListe(pracownicy,['imie','nazwisko','email','stanowisko','dzial','numer_pracownika'],'pracownik');return <>
      <SectionHeader title="Pracownicy" subtitle="Osoby, do których mogą być przypisywane środki trwałe." buttonLabel="Dodaj pracownika" onClick={()=>otworzDodawanieSlownika('pracownik')} icon={<PersonAddAltOutlined/>}/>
      <KontrolkiListy placeholder="Szukaj po nazwisku, numerze pracownika, e-mailu, stanowisku lub dziale..."/>
      <SimpleList>
        <Box sx={{display:{xs:'none',xl:'grid'},gridTemplateColumns:'1.3fr 1.35fr 1fr 1fr 105px 100px',gap:1.5,px:1,py:1,bgcolor:'#f8fafc',borderRadius:1.5,fontWeight:850,fontSize:13}}><span>Pracownik</span><span>E-mail</span><span>Stanowisko</span><span>Dział</span><span>Status</span><span>Akcje</span></Box>
        {meta.dane.length===0?<Typography color="text.secondary" sx={{py:4,textAlign:'center'}}>Brak pracowników spełniających wybrane kryteria.</Typography>:meta.dane.map(x=><Box key={x.id_pracownika} sx={{display:'grid',gridTemplateColumns:{xs:'1fr',xl:'1.3fr 1.35fr 1fr 1fr 105px 100px'},gap:1.5,px:1,py:1.4,borderBottom:'1px solid #edf1f6',alignItems:'center',bgcolor:x.aktywny?'transparent':'#f5f6f8',opacity:x.aktywny?1:.62}}>
          <Box><Typography variant="body2" fontWeight={850}>{x.imie} {x.nazwisko}</Typography><Typography variant="caption" color="primary" fontWeight={800}>Nr {x.numer_pracownika||'—'}</Typography></Box>
          <Typography variant="body2">{x.email||'—'}</Typography><Typography variant="body2">{x.stanowisko||'—'}</Typography><Typography variant="body2">{x.dzial||'—'}</Typography>
          <Chip size="small" label={x.aktywny?'Aktywny':'Nieaktywny'} sx={{justifySelf:'start',bgcolor:x.aktywny?'#e7f7ed':'#eef2f6',color:x.aktywny?'#21833d':'#526173',fontWeight:800}}/>
          <Box sx={{display:'flex',gap:.3,alignItems:'center'}}><Tooltip title="Edytuj pracownika"><IconButton size="small" color="primary" onClick={()=>otworzEdycjeSlownika('pracownik',x)}><EditOutlined fontSize="small"/></IconButton></Tooltip><Tooltip title={x.aktywny?'Dezaktywuj pracownika':'Aktywuj pracownika'}><Switch size="small" checked={!!x.aktywny} onChange={()=>zmienStatusSlownika('pracownik',x)}/></Tooltip></Box>
        </Box>)}
        <PaginacjaListy meta={meta}/>
      </SimpleList>
    </>})()}

    {sekcja==='firmy-serwisowe' && (()=>{const meta=przygotujListe(serwisy,['nazwa','nip','email','telefon','osoba_kontaktowa','adres'],'serwis');return <>
      <SectionHeader title="Firmy serwisowe" subtitle="Dane firm wykorzystywanych przy obsłudze serwisowej sprzętu." buttonLabel="Dodaj firmę serwisową" onClick={()=>otworzDodawanieSlownika('serwis')} icon={<BusinessOutlined/>}/>
      <KontrolkiListy placeholder="Szukaj po nazwie, NIP-ie, e-mailu, telefonie lub osobie kontaktowej..."/>
      <SimpleList>
        <Box sx={{display:{xs:'none',xl:'grid'},gridTemplateColumns:'1.35fr .9fr 1.25fr 1fr 105px 100px',gap:1.5,px:1,py:1,bgcolor:'#f8fafc',borderRadius:1.5,fontWeight:850,fontSize:13}}><span>Firma</span><span>NIP</span><span>Kontakt</span><span>Osoba kontaktowa</span><span>Status</span><span>Akcje</span></Box>
        {meta.dane.length===0?<Typography color="text.secondary" sx={{py:4,textAlign:'center'}}>Brak firm spełniających wybrane kryteria.</Typography>:meta.dane.map(x=><Box key={x.id_firmy_serwisowej} sx={{display:'grid',gridTemplateColumns:{xs:'1fr',xl:'1.35fr .9fr 1.25fr 1fr 105px 100px'},gap:1.5,px:1,py:1.4,borderBottom:'1px solid #edf1f6',alignItems:'center',bgcolor:x.aktywna?'transparent':'#f6f7f9',opacity:x.aktywna?1:.67}}>
          <Box><Typography variant="body2" fontWeight={850}>{x.nazwa}</Typography>{x.adres&&<Typography variant="caption" color="text.secondary">{x.adres}</Typography>}</Box>
          <Typography variant="body2" fontWeight={800}>{x.nip||'—'}</Typography>
          <Box><Typography variant="body2">{x.email||'—'}</Typography><Typography variant="caption" color="text.secondary">{x.telefon||''}</Typography></Box>
          <Typography variant="body2">{x.osoba_kontaktowa||'—'}</Typography>
          <Chip size="small" label={x.aktywna?'Aktywna':'Nieaktywna'} sx={{justifySelf:'start',bgcolor:x.aktywna?'#e7f7ed':'#eef2f6',color:x.aktywna?'#21833d':'#526173',fontWeight:800}}/>
          <Box sx={{display:'flex',gap:.3,alignItems:'center'}}><Tooltip title="Edytuj firmę"><IconButton size="small" color="primary" onClick={()=>otworzEdycjeSlownika('serwis',x)}><EditOutlined fontSize="small"/></IconButton></Tooltip><Tooltip title={x.aktywna?'Dezaktywuj firmę':'Aktywuj firmę'}><Switch size="small" checked={!!x.aktywna} onChange={()=>zmienStatusSlownika('serwis',x)}/></Tooltip></Box>
        </Box>)}
        <PaginacjaListy meta={meta}/>
      </SimpleList>
    </>})()}

    {sekcja==='producenci' && (()=>{const meta=przygotujListe(producenci,['nazwa','opis'],'producent');return <>
      <SectionHeader title="Producenci" subtitle="Producenci dostępni przy ewidencjonowaniu sprzętu." buttonLabel="Dodaj producenta" onClick={()=>otworzDodawanieSlownika('producent')} icon={<FactoryOutlined/>}/>
      <KontrolkiListy placeholder="Szukaj po nazwie lub opisie..." pokazKod={false}/>
      <SimpleList>
        <Box sx={{display:{xs:'none',xl:'grid'},gridTemplateColumns:'1.5fr 2fr 100px 105px 100px',gap:1.5,px:1,py:1,bgcolor:'#f8fafc',borderRadius:1.5,fontWeight:850,fontSize:13}}><span>Nazwa</span><span>Opis</span><span>Użycia</span><span>Status</span><span>Akcje</span></Box>
        {meta.dane.length===0?<Typography color="text.secondary" sx={{py:4,textAlign:'center'}}>Brak producentów spełniających wybrane kryteria.</Typography>:meta.dane.map(x=><Box key={x.id_producenta} sx={{display:'grid',gridTemplateColumns:{xs:'1fr',xl:'1.5fr 2fr 100px 105px 100px'},gap:1.5,px:1,py:1.4,borderBottom:'1px solid #edf1f6',alignItems:'center',bgcolor:x.aktywny?'transparent':'#f6f7f9',opacity:x.aktywny?1:.67}}>
          <Typography variant="body2" fontWeight={850}>{x.nazwa}</Typography><Typography variant="body2" color="text.secondary">{x.opis||'—'}</Typography><Typography variant="body2">{x.uzycia||0}</Typography>
          <Chip size="small" label={x.aktywny?'Aktywny':'Nieaktywny'} sx={{justifySelf:'start',bgcolor:x.aktywny?'#e7f7ed':'#eef2f6',color:x.aktywny?'#21833d':'#526173',fontWeight:800}}/>
          <Box sx={{display:'flex',gap:.3,alignItems:'center'}}><Tooltip title="Edytuj producenta"><IconButton size="small" color="primary" onClick={()=>otworzEdycjeSlownika('producent',x)}><EditOutlined fontSize="small"/></IconButton></Tooltip><Tooltip title={x.aktywny?'Dezaktywuj producenta':'Aktywuj producenta'}><Switch size="small" checked={!!x.aktywny} onChange={()=>zmienStatusSlownika('producent',x)}/></Tooltip></Box>
        </Box>)}
        <PaginacjaListy meta={meta}/>
      </SimpleList>
    </>})()}

    {sekcja==='wnioski' && maUprawnienie('ASSET_DELETE_APPROVE') && <>
      <SectionHeader title="Wnioski o trwałe usunięcie" subtitle="Decyzje administratora dotyczące trwałego usuwania środków." icon={<DeleteOutline/>}/>

      <Paper sx={{...card,p:1.2,mb:2}}>
        <Box sx={{display:'flex',gap:1,flexWrap:'wrap'}}>
          {[
            ['OCZEKUJE','Oczekujące'],['ZATWIERDZONY','Zaakceptowane'],['ODRZUCONY','Odrzucone'],['WSZYSTKIE','Wszystkie']
          ].map(([kod,label])=><Button key={kod} size="small" variant={statusWnioskow===kod?'contained':'text'} onClick={()=>setStatusWnioskow(kod)} sx={{textTransform:'none',fontWeight:800}}>
            {label}{kod==='OCZEKUJE' && dashboard.oczekujace.length>0 ? ` (${dashboard.oczekujace.length})` : ''}
          </Button>)}
        </Box>
      </Paper>

      <Paper sx={{...card,p:2}}>
        {wnioski.length===0 ? <Box sx={{py:5,textAlign:'center'}}>
          <DeleteOutline sx={{fontSize:38,color:'#a6b1bf',mb:1}}/>
          <Typography fontWeight={850}>Brak wniosków</Typography>
          <Typography variant="body2" color="text.secondary">Nie ma wniosków dla wybranego statusu.</Typography>
        </Box> :
          wnioski.map(w=>{const s=snapshot(w),sc=statusColor(w.status);return <Box key={w.id_wniosku} sx={{py:1.7,borderBottom:'1px solid #edf1f6',display:'grid',gridTemplateColumns:{xs:'1fr',lg:'1.25fr 1.45fr .85fr auto'},gap:2,alignItems:'center'}}>
            <Box>
              <Typography variant="body2" fontWeight={900}>{w.nazwa_indeksu||s.nazwa_indeksu||'Usunięty środek'}</Typography>
              <Typography variant="caption" color="text.secondary">INW: {w.numer_inw||s.numer_inw||'—'} · SN: {w.numer_seryjny||s.numer_seryjny||'—'}</Typography>
            </Box>
            <Box>
              <Typography variant="body2"><b>{w.wnioskodawca_nazwa||'Użytkownik'}</b></Typography>
              <Typography variant="caption" color="text.secondary">{new Date(w.data_zgloszenia).toLocaleString('pl-PL')}</Typography>
              <Typography variant="body2" sx={{mt:.5}}><b>Powód:</b> {w.powod}</Typography>
            </Box>
            <Box>
              <Chip size="small" label={w.status==='OCZEKUJE'?'Oczekujący':w.status==='ZATWIERDZONY'?'Zaakceptowany':w.status==='ODRZUCONY'?'Odrzucony':w.status} sx={{bgcolor:sc.bg,color:sc.fg,fontWeight:850}}/>
              {w.komentarz_administratora && <Typography variant="caption" color="text.secondary" sx={{display:'block',mt:.6}}>{w.komentarz_administratora}</Typography>}
            </Box>
            {w.status==='OCZEKUJE' ? <Button variant="outlined" onClick={()=>{setWybrany(w);setKomentarz('');setOpenDecyzja(true);}}>Rozpatrz</Button> : w.status==='ZATWIERDZONY' ? <Button size="small" variant="outlined" startIcon={<PictureAsPdfOutlined/>} onClick={()=>drukujProtokolUsuniecia(w)} sx={{whiteSpace:'nowrap'}}>Protokół PDF</Button> : <Typography variant="caption" color="text.secondary">Decyzja zapisana</Typography>}
          </Box>;})
        }
      </Paper>
    </>}

    {sekcja==='role' && <>
      <SectionHeader title="Role i uprawnienia" subtitle="Czytelny podgląd tego, jakie czynności może wykonywać każda rola." icon={<ShieldOutlined/>}/>
      <Paper sx={{...card,p:2,overflowX:'auto'}}>
        <Box sx={{minWidth:760}}>
          <Box sx={{display:'grid',gridTemplateColumns:'2.2fr repeat(4,1fr)',gap:1,px:1,py:1.2,bgcolor:'#f8fafc',borderRadius:1.5,alignItems:'center'}}>
            <Typography variant="body2" fontWeight={900}>Funkcja</Typography>
            {['USER','OPERATOR','KSIEGOWY','ADMIN'].map(r=><Typography key={r} variant="body2" fontWeight={900} textAlign="center">{rolaLabel(r)}</Typography>)}
          </Box>
          {uprawnieniaWidoczne.map(([kod,label])=><Box key={kod} sx={{display:'grid',gridTemplateColumns:'2.2fr repeat(4,1fr)',gap:1,px:1,py:.8,borderBottom:'1px solid #edf1f6',alignItems:'center'}}>
            <Typography variant="body2" fontWeight={750}>{label}</Typography>
            {['USER','OPERATOR','KSIEGOWY','ADMIN'].map(r=><Box key={r} sx={{display:'grid',placeItems:'center'}}>
              <Checkbox checked={!!macierzUprawnien[r]?.has(kod)} disabled sx={{'&.Mui-disabled':{color:macierzUprawnien[r]?.has(kod)?'#2364d8':'#c8d1dc'}}}/>
            </Box>)}
          </Box>)}
        </Box>
      </Paper>
    </>}

    {sekcja==='logi' && <Logi/>}

    <Dialog open={open} onClose={()=>setOpen(false)} fullWidth maxWidth="sm">
      <DialogTitle>Dodaj użytkownika</DialogTitle>
      <DialogContent sx={{display:'grid',gap:2,pt:'12px !important'}}>
        {kontoBlad && <Alert severity="error" onClose={()=>setKontoBlad('')}>{kontoBlad}</Alert>}
        <TextField label="Imię" value={konto.imie} onChange={e=>setKonto(k=>({...k,imie:e.target.value}))}/>
        <TextField label="Nazwisko" value={konto.nazwisko} onChange={e=>setKonto(k=>({...k,nazwisko:e.target.value}))}/>
        <TextField type="email" label="E-mail" value={konto.email} onChange={e=>setKonto(k=>({...k,email:e.target.value}))}/>
        <TextField type={pokazTymczasowe?'text':'password'} label="Hasło tymczasowe" helperText="Min. 8 znaków, 1 wielka litera i 1 znak specjalny" value={konto.haslo_tymczasowe} onChange={e=>setKonto(k=>({...k,haslo_tymczasowe:e.target.value}))}
          InputProps={{endAdornment:<InputAdornment position="end"><IconButton onClick={()=>setPokazTymczasowe(v=>!v)} edge="end">{pokazTymczasowe?<VisibilityOff/>:<Visibility/>}</IconButton></InputAdornment>}}/>
        <TextField type={pokazPowtorzTymczasowe?'text':'password'} label="Powtórz hasło tymczasowe" value={konto.powtorz_haslo} onChange={e=>setKonto(k=>({...k,powtorz_haslo:e.target.value}))}
          InputProps={{endAdornment:<InputAdornment position="end"><IconButton onClick={()=>setPokazPowtorzTymczasowe(v=>!v)} edge="end">{pokazPowtorzTymczasowe?<VisibilityOff/>:<Visibility/>}</IconButton></InputAdornment>}}/>
        <TextField select label="Rola" value={konto.id_roli} onChange={e=>setKonto(k=>({...k,id_roli:e.target.value}))}>
          {role.map(r=><MenuItem key={r.id_roli} value={r.id_roli}>{rolaLabel(r.nazwa)}</MenuItem>)}
        </TextField>
      </DialogContent>
      <DialogActions><Button onClick={()=>{setOpen(false);setKontoBlad('');}}>Anuluj</Button><Button variant="contained" onClick={potwierdzFormularzKonta}>Przejdź do potwierdzenia</Button></DialogActions>
    </Dialog>

    <Dialog open={kontoPotwierdzOpen} onClose={()=>setKontoPotwierdzOpen(false)} fullWidth maxWidth="sm">
      <DialogTitle>Potwierdź utworzenie konta</DialogTitle>
      <DialogContent sx={{pt:'10px !important'}}>
        <Alert severity="info" sx={{mb:2}}>Sprawdź dane. Login zostanie nadany automatycznie po utworzeniu konta.</Alert>
        <Paper variant="outlined" sx={{p:2,borderRadius:2,bgcolor:'#fbfcfe'}}>
          {[
            ['Imię i nazwisko',`${konto.imie||''} ${konto.nazwisko||''}`.trim()],
            ['E-mail',konto.email],
            ['Rola',rolaLabel(role.find(r=>String(r.id_roli)===String(konto.id_roli))?.nazwa)]
          ].map(([k,v])=><Box key={k} sx={{display:'grid',gridTemplateColumns:'150px 1fr',gap:1,py:.7,borderBottom:'1px solid #eef2f6'}}>
            <Typography variant="body2" color="text.secondary" fontWeight={750}>{k}</Typography>
            <Typography variant="body2" fontWeight={800}>{v||'—'}</Typography>
          </Box>)}
        </Paper>
      </DialogContent>
      <DialogActions><Button onClick={()=>setKontoPotwierdzOpen(false)}>Wróć do edycji</Button><Button variant="contained" onClick={dodaj}>Tak, utwórz konto</Button></DialogActions>
    </Dialog>

    <Dialog open={!!slownikOpen} onClose={()=>setSlownikOpen(null)} fullWidth maxWidth="md">
      <DialogTitle>{slownikTryb==='edytuj'?'Edytuj':'Dodaj'} {slownikOpen==='lokalizacja'?'lokalizację':slownikOpen==='pracownik'?'pracownika':slownikOpen==='producent'?'producenta':'firmę serwisową'}</DialogTitle>
      <DialogContent sx={{pt:'12px !important'}}>
        <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',sm:'1fr 1fr'},gap:2}}>
          {slownikOpen==='lokalizacja' && <>
            <TextField required label="Nazwa lokalizacji" value={slownikForm.nazwa||''} onChange={e=>setSlownikForm(x=>({...x,nazwa:e.target.value}))}/>
            <TextField required label="Kod lokalizacji" value={slownikForm.kod_lokalizacji||''} helperText="Unikalny kod, np. GDY-01 lub MAG/02." inputProps={{maxLength:20}} onChange={e=>setSlownikForm(x=>({...x,kod_lokalizacji:e.target.value.toUpperCase().replace(/\s/g,'')}))}/>
            <TextField label="Miasto" value={slownikForm.miasto||''} onChange={e=>setSlownikForm(x=>({...x,miasto:e.target.value}))}/>
            <TextField label="Ulica" value={slownikForm.ulica||''} onChange={e=>setSlownikForm(x=>({...x,ulica:e.target.value}))}/>
            <TextField label="Numer budynku" value={slownikForm.numer_budynku||''} onChange={e=>setSlownikForm(x=>({...x,numer_budynku:e.target.value}))}/>
            <TextField label="Budynek / oddział" value={slownikForm.budynek||''} onChange={e=>setSlownikForm(x=>({...x,budynek:e.target.value}))}/>
            <TextField label="Piętro" value={slownikForm.pietro||''} placeholder="np. 2" onChange={e=>setSlownikForm(x=>({...x,pietro:e.target.value}))}/>
            <TextField label="Pokój / pomieszczenie" value={slownikForm.pomieszczenie||''} placeholder="np. 214" onChange={e=>setSlownikForm(x=>({...x,pomieszczenie:e.target.value}))}/>
            <TextField sx={{gridColumn:{sm:'1 / -1'}}} multiline minRows={3} label="Opis / uwagi" value={slownikForm.opis||''} onChange={e=>setSlownikForm(x=>({...x,opis:e.target.value}))}/>
          </>}
          {slownikOpen==='pracownik' && <>
            <TextField required label="Imię" value={slownikForm.imie||''} onChange={e=>setSlownikForm(x=>({...x,imie:e.target.value}))}/>
            <TextField required label="Nazwisko" value={slownikForm.nazwisko||''} onChange={e=>setSlownikForm(x=>({...x,nazwisko:e.target.value}))}/>
            <TextField required label="Numer pracownika" value={slownikForm.numer_pracownika||''} inputProps={{inputMode:'numeric',maxLength:5}} helperText="Dokładnie 5 cyfr. Ten numer jednoznacznie identyfikuje pracownika." onChange={e=>setSlownikForm(x=>({...x,numer_pracownika:e.target.value.replace(/\D/g,'').slice(0,5)}))}/>
            <TextField type="email" label="E-mail (opcjonalnie)" value={slownikForm.email||''} helperText="Jeżeli podasz e-mail, również musi być unikalny." onChange={e=>setSlownikForm(x=>({...x,email:e.target.value}))}/>
            <TextField label="Stanowisko" value={slownikForm.stanowisko||''} onChange={e=>setSlownikForm(x=>({...x,stanowisko:e.target.value}))}/>
            <TextField label="Dział" value={slownikForm.dzial||''} onChange={e=>setSlownikForm(x=>({...x,dzial:e.target.value}))}/>
          </>}
          {slownikOpen==='producent' && <>
            <TextField required sx={{gridColumn:{sm:'1 / -1'}}} label="Nazwa producenta" value={slownikForm.nazwa||''} onChange={e=>setSlownikForm(x=>({...x,nazwa:e.target.value}))}/>
            <TextField sx={{gridColumn:{sm:'1 / -1'}}} multiline minRows={3} label="Opis (opcjonalnie)" value={slownikForm.opis||''} onChange={e=>setSlownikForm(x=>({...x,opis:e.target.value}))}/>
          </>}
          {slownikOpen==='serwis' && <>
            <TextField required label="Nazwa firmy serwisowej" value={slownikForm.nazwa||''} onChange={e=>setSlownikForm(x=>({...x,nazwa:e.target.value}))}/>
            <TextField required label="NIP" value={slownikForm.nip||''} inputProps={{inputMode:'numeric',maxLength:10}} helperText="10 cyfr. NIP jest unikalnym identyfikatorem firmy w systemie." onChange={e=>setSlownikForm(x=>({...x,nip:e.target.value.replace(/\D/g,'').slice(0,10)}))}/>
            <TextField type="email" label="E-mail" value={slownikForm.email||''} onChange={e=>setSlownikForm(x=>({...x,email:e.target.value}))}/>
            <TextField label="Telefon" value={slownikForm.telefon||''} onChange={e=>setSlownikForm(x=>({...x,telefon:e.target.value}))}/>
            <TextField sx={{gridColumn:{sm:'1 / -1'}}} label="Adres" value={slownikForm.adres||''} onChange={e=>setSlownikForm(x=>({...x,adres:e.target.value}))}/>
            <TextField sx={{gridColumn:{sm:'1 / -1'}}} label="Osoba kontaktowa" value={slownikForm.osoba_kontaktowa||''} onChange={e=>setSlownikForm(x=>({...x,osoba_kontaktowa:e.target.value}))}/>
            <TextField sx={{gridColumn:{sm:'1 / -1'}}} multiline minRows={3} label="Uwagi" value={slownikForm.uwagi||''} onChange={e=>setSlownikForm(x=>({...x,uwagi:e.target.value}))}/>
          </>}
        </Box>
        <Alert severity="info" sx={{mt:2}}>System sprawdza duplikaty bez względu na wielkość liter i zbędne spacje. Rekordy używane historycznie można bezpiecznie dezaktywować.</Alert>
      </DialogContent>
      <DialogActions><Button onClick={()=>setSlownikOpen(null)}>Anuluj</Button><Button variant="contained" onClick={zapiszSlownik}>{slownikTryb==='edytuj'?'Zapisz zmiany':'Dodaj'}</Button></DialogActions>
    </Dialog>

    <Dialog open={slownikPotwierdzOpen} onClose={()=>setSlownikPotwierdzOpen(false)} fullWidth maxWidth="sm">
      <DialogTitle>Potwierdź dodanie</DialogTitle>
      <DialogContent sx={{pt:'10px !important'}}>
        <Alert severity="info" sx={{mb:2}}>Sprawdź dane przed zapisaniem. Jeśli coś chcesz poprawić, wróć do formularza.</Alert>
        <Paper variant="outlined" sx={{p:2,borderRadius:2,bgcolor:'#fbfcfe'}}>
          {podsumowanieSlownika().filter(([,v])=>String(v||'').trim()).map(([etykieta,wartosc])=><Box key={etykieta} sx={{display:'grid',gridTemplateColumns:'150px 1fr',gap:1,py:.65,borderBottom:'1px solid #eef2f6'}}>
            <Typography variant="body2" color="text.secondary" fontWeight={750}>{etykieta}</Typography>
            <Typography variant="body2" fontWeight={800}>{wartosc}</Typography>
          </Box>)}
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button onClick={()=>setSlownikPotwierdzOpen(false)}>Wróć do edycji</Button>
        <Button variant="contained" onClick={wykonajZapisSlownika}>Tak, dodaj</Button>
      </DialogActions>
    </Dialog>

    <Dialog open={editOpen} onClose={()=>setEditOpen(false)} fullWidth maxWidth="sm">
      <DialogTitle>Edytuj użytkownika</DialogTitle>
      <DialogContent sx={{display:'grid',gap:2,pt:'12px !important'}}>{kontoEdit&&<>
        <TextField label="Login" value={kontoEdit.login||''} disabled/>
        <TextField label="E-mail" type="email" value={kontoEdit.email||''} onChange={e=>setKontoEdit(k=>({...k,email:e.target.value}))}/>
        <TextField label="Imię" value={kontoEdit.imie||''} onChange={e=>setKontoEdit(k=>({...k,imie:e.target.value}))}/>
        <TextField label="Nazwisko" value={kontoEdit.nazwisko||''} onChange={e=>setKontoEdit(k=>({...k,nazwisko:e.target.value}))}/>
        <TextField select label="Rola" value={kontoEdit.id_roli||''} onChange={e=>setKontoEdit(k=>({...k,id_roli:e.target.value}))}>{role.map(r=><MenuItem key={r.id_roli} value={r.id_roli}>{rolaLabel(r.nazwa)}</MenuItem>)}</TextField>
        <TextField select label="Status konta" value={kontoEdit.status_konta||'NIEAKTYWNE'} onChange={e=>setKontoEdit(k=>({...k,status_konta:e.target.value}))}>
          <MenuItem value="AKTYWNE">Aktywne</MenuItem><MenuItem value="NIEAKTYWNE">Nieaktywne</MenuItem>
        </TextField>
      </>}</DialogContent>
      <DialogActions><Button onClick={()=>setEditOpen(false)}>Anuluj</Button><Button variant="contained" onClick={zapiszEdycje}>Zapisz zmiany</Button></DialogActions>
    </Dialog>

    <Dialog open={deleteOpen} onClose={()=>setDeleteOpen(false)} fullWidth maxWidth="sm">
      <DialogTitle>Trwałe usunięcie użytkownika</DialogTitle>
      <DialogContent><Alert severity="warning" sx={{mb:2}}>Konto zostanie usunięte fizycznie tylko wtedy, gdy nie ma powiązanej historii operacji.</Alert><Typography>Czy na pewno chcesz usunąć konto <b>{kontoEdit?.login}</b>?</Typography></DialogContent>
      <DialogActions><Button onClick={()=>setDeleteOpen(false)}>Anuluj</Button><Button color="error" variant="contained" onClick={usunKonto}>Usuń trwale</Button></DialogActions>
    </Dialog>

    <Dialog open={openDecyzja} onClose={()=>setOpenDecyzja(false)} fullWidth maxWidth="sm">
      <DialogTitle>Rozpatrz wniosek o usunięcie</DialogTitle>
      <DialogContent sx={{pt:'12px !important'}}>
        {wybrany && (()=>{const s=snapshot(wybrany);return <>
          <Alert severity="warning" sx={{mb:2}}>Akceptacja spowoduje trwałe usunięcie środka. Informacja o wniosku i kopia danych środka pozostaną w historii.</Alert>
          <Paper variant="outlined" sx={{p:1.7,mb:2,borderRadius:2,bgcolor:'#fbfcfe'}}>
            <Typography fontWeight={900}>{wybrany.nazwa_indeksu||s.nazwa_indeksu||'Środek trwały'}</Typography>
            <Typography variant="body2" color="text.secondary" sx={{mt:.4}}>INW: {wybrany.numer_inw||s.numer_inw||'—'} · SN: {wybrany.numer_seryjny||s.numer_seryjny||'—'}</Typography>
            <Typography variant="body2" sx={{mt:1}}><b>Wnioskodawca:</b> {wybrany.wnioskodawca_nazwa||'—'}</Typography>
            <Typography variant="body2"><b>Powód:</b> {wybrany.powod}</Typography>
          </Paper>
        </>})()}
        <TextField fullWidth multiline minRows={3} label="Komentarz administratora" value={komentarz} onChange={e=>setKomentarz(e.target.value)} helperText="Powód jest obowiązkowy przy odrzuceniu wniosku. Przy akceptacji komentarz jest opcjonalny."/>
      </DialogContent>
      <DialogActions><Button onClick={()=>setOpenDecyzja(false)}>Anuluj</Button><Button variant="outlined" onClick={()=>decyzja('ODRZUCONY')}>Odrzuć</Button><Button color="error" variant="contained" onClick={()=>decyzja('ZATWIERDZONY')}>Zatwierdź i usuń</Button></DialogActions>
    </Dialog>
  </Box>;
}
